import { render, staticRenderFns } from "./RPSChoices.vue?vue&type=template&id=5a6340f6&scoped=true"
import script from "./RPSChoices.vue?vue&type=script&lang=js"
export * from "./RPSChoices.vue?vue&type=script&lang=js"
import style0 from "./RPSChoices.vue?vue&type=style&index=0&id=5a6340f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6340f6",
  null
  
)

export default component.exports